<div class="widget-framework">
  <jafar-page-widget [contents]="contentTemplate" [actions]="actionTemplate" >
      <div title>Request Tasks</div>
      <div subtitle> View List of CIP Request Tasks  </div>
  </jafar-page-widget>
</div>

<ng-template #contentTemplate >
  View a List of CIP Request Tasks.<br> You also have the ability to Search for a Request Tasks by: <b>CIP Id</b> or <b>Task Id</b><br>
</ng-template>

<ng-template #actionTemplate>
  <button mat-flat-button matTooltip="Manage Customers" (click)="buttonClicked()" class="manage-azure-button">
      Go To Request Tasks
      <mat-icon>shortcut</mat-icon>
  </button>
</ng-template>